'use client';

import CarouselSkeleton from '@components/carousel/carousel-skeleton';
import HorizontalSlider from '@components/horizontal-slider/horizontal-slider';
import RestaurantCardContent from '@components/restaurants/restaurant-card-content/restaurant-card-content';
import {
  v2_useBranches,
  v2_useCart,
  v2_useProductTaxons,
} from '@crocodille/common';
import { getDayOfWeek, isNone } from '@crocodille/util';
import { useGeolocation } from '@hooks/use-geolocation';
import { useTranslation } from 'next-i18next';
import ShippingPageLayout from '../shipping-page-layout-2/shipping-page-layout-2';

export function ShippingPageLayoutDynamic() {
  const { t } = useTranslation();

  const { data: cart } = v2_useCart();
  const { data: taxons } = v2_useProductTaxons(cart?.branchCode);
  const { data: locationData } = useGeolocation();
  const { data: branches } = v2_useBranches(
    locationData
      ? {
          longitude: locationData.coords.longitude,
          latitude: locationData.coords.latitude,
        }
      : null,
  );

  const today = getDayOfWeek(new Date());

  return (
    <>
      <ShippingPageLayout.Products>
        {isNone(taxons) || taxons?.length === 0 ? (
          <CarouselSkeleton />
        ) : (
          <HorizontalSlider
            title={t('products.title')}
            isAdditionalPadding
            href="/menu"
          >
            {taxons.map((taxon) => (
              <HorizontalSlider.Slide
                key={taxon.id}
                src={taxon.image}
                href={`/menu/${taxon.slug}`}
                label={taxon.name}
                size="small"
                asAnchor
              >
                <h3>{taxon.name}</h3>
              </HorizontalSlider.Slide>
            ))}
          </HorizontalSlider>
        )}
      </ShippingPageLayout.Products>
      <ShippingPageLayout.Restaurants>
        {isNone(branches) || branches?.length === 0 ? (
          <CarouselSkeleton />
        ) : (
          <HorizontalSlider
            title={`${t('shipping.branches_title')} (${branches.length})`}
            isAdditionalPadding
          >
            {branches.map((branch) => (
              <HorizontalSlider.Slide
                key={branch.code}
                src={branch.imagePath}
                label={branch.name}
                size="small"
                href={null}
                isSmallImg
              >
                <RestaurantCardContent
                  name={branch.name}
                  key={branch.code}
                  address={branch.address}
                  openFrom={branch.openingHours[today]?.openFrom}
                  openTo={branch.openingHours[today]?.openTo}
                  deliveryFrom={branch.openingHours[today]?.deliveryFrom}
                  deliveryTo={branch.openingHours[today]?.deliveryTo}
                  distance={branch.distance}
                />
              </HorizontalSlider.Slide>
            ))}
          </HorizontalSlider>
        )}
      </ShippingPageLayout.Restaurants>
    </>
  );
}

export default ShippingPageLayoutDynamic;
